module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "epigraph"
    }
  }, [_c('blockquote', {
    staticClass: "blockquote1"
  }, [_c('p', {
    staticClass: "epi"
  }, [_c('span', {
    attrs: {
      "aria-label": "vi",
      "epub:type": "pagebreak",
      "id": "page_vi",
      "role": "doc-pagebreak",
      "title": "vi"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "vii",
      "epub:type": "pagebreak",
      "id": "page_vii",
      "role": "doc-pagebreak",
      "title": "vii"
    }
  }, [_vm._v("They wanna try and keep everything hushed up. Like it’s some kind of big secret.… They won’t tell us what it is. They don’t wanna talk to me. Because I’m an old dumb farmer, I’m not supposed to know anything. But it’s not gonna be covered up. Because I’m gonna bring it out in the open for people to see.")])])]), _vm._v(" "), _c('p', {
    staticClass: "epi-att"
  }, [_vm._v("—Wilbur Earl Tennant")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7b29dba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781501172830/xhtml/epigraph.vue
// module id = 69
// module chunks = 0